import React from 'react';
import './styles/DesignerStyles.css';

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';

import wordCupLogo from './Images/WC-logo.png';
import clockIcon from './Images/Clock-Icon.svg';

import { checkForCode, getRoomId, androidBackButton } from './Utils';

class Lobby extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      timeoutID: 0,
      sub: '',

      coloredTeams: [],

      room: { teams: [] },
    };
  }

  onPause = () => {
    console.log("App paused");
    if (this.state.timeoutID) {
      clearTimeout(this.state.timeoutID);
    }
  }

  onResume = () => {
    console.log("App resumed");
    if (this.state.room && this.state.room._id) {
       console.log("Forcing immediate loadPage on resume");
       if (this.state.timeoutID) clearTimeout(this.state.timeoutID);
       this.loadPage(); 
    } else {
       console.log("Resumed but no room ID yet.");
    }
 }

  async componentDidMount() {
    console.log('roomID: ' + getRoomId());
    androidBackButton(this.handleGoBackRoom);

    let code = this.props.cookies.get('code');

    try {
      this.setState({
        sub: code,
      });

      const roomData = await checkForCode(
        'GET',
        `/api/rooms/${getRoomId()}`,
        this.props,
        null
      );

      this.setState({
        room: roomData,
        coloredTeams: roomData.teams,
      });
    } catch (error) {
      console.error('An error occurred:', error);
    }
    document.addEventListener('pause', this.onPause, false);
    document.addEventListener('resume', this.onResume, false);
  }

  componentWillUnmount() {
    document.removeEventListener('pause', this.onPause, false);
    document.removeEventListener('resume', this.onResume, false);
  }

  loadPage = async () => {
    let data = await checkForCode(
      'GET',
      `/api/rooms/${getRoomId()}`,
      this.props,
      null
    );

    if (data.hasGameStarted) {
      this.props.navigate(`/game/${getRoomId()}`);
    } else {
      this.setState({
        room: data,
        coloredTeams: data.teams,
      });
    }
  };

  handleGoBackRoom = async () => {
    await checkForCode(
      'PUT',
      `/api/rooms/${getRoomId()}/teams/leave`,
      this.props,
      null
    );

    this.props.navigate(`/TeamAndWords/${getRoomId()}`, {
      state: {
        chosenTeam: this.props.location.state.chosenTeam,
      },
    });
  };

  handleStartGame = async () => {
    await checkForCode(
      'PUT',
      `/api/rooms/${getRoomId()}/startGame`,
      this.props,
      null
    );

    console.log('startGame');
    this.props.navigate(`/game/${getRoomId()}`);
  };

  handleQRButtonPress = () => {
    //remains to bе written
    this.props.navigate(`/QRCodePage/${getRoomId()}`);
  };

  render() {
    clearTimeout(this.state.timeoutID);
    if (this.state.room._id) {
      // eslint-disable-next-line
      this.state.timeoutID = setTimeout(() => {
        this.loadPage();
      }, 1000);
    }

    return (
      <div className="Home">
        <div className="nonOwnerMessageDiv">
          <img
            className="wordCupLogoImg"
            src={wordCupLogo}
            alt="word Cup Logo"
          />
          <img src={clockIcon} alt="clock Icon" />
          <p className="pleaseWaitParagraph">
            Моля изчакайте! <br /> Играта ще започне след момент
          </p>
          <p className="roomIDParagraph">
            Номер на стаята: {this.state.room.roomID ? this.state.room.roomID : ''}
          </p>
        </div>

        {this.state.room.teams.length !== 0 ? (
          this.state.room.teams.map((element, index) => (
            <div key={index} className="teamsMapOuterDiv">
              <div
                className={`teamNameHolder ${this.state.coloredTeams[index].teamName}`}>
                {element.displayName}
              </div>

              <div
                className={`teamHolder ${this.state.coloredTeams[index].teamName}`}>
                {element.teamPlayers.map((player) => {
                  return (
                    <div className="playerCircleIcon" key={player.sub}>
                      <div
                        className="img"
                        style={{
                          backgroundImage: `url('${
                            window.viewType === 'phone'
                              ? `${process.env.REACT_APP_MOBILE_BACKEND_URL}`
                              : ''
                          }/api/${player.sub}/user-picture')`,
                        }}></div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))
        ) : (
          <></>
        )}

        <div className="arrowBackButtonDiv_CG QR">
          <DesignerButton
            class="arrowBackButton"
            onClick={() => {this.props.navigate(`/QRCodePage/${getRoomId()}`);}}></DesignerButton>
        </div>

        <DesignerButton
          style={{ position: 'absolute', left: '20px', top: '75px' }}
          class="arrowBackButton"
          onClick={this.handleGoBackRoom}></DesignerButton>

        <div className="ButtonHolder">
          {this.state.room.owner ? (
            this.state.room.owner === this.state.sub ? (
              <DesignerButton
                class="filledButton"
                onClick={this.handleStartGame}
                buttonText="Стартирай Игра"></DesignerButton>
            ) : (
              <></>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
}

export default withCookies(Lobby);
